"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6a6 6 0 100 12 6 6 0 000-12zm.42 8.883h-.936v-.992h.935v.992zm.257-2.565l-.282.194v.597h-.887v-.903l.75-.533c.42-.298.67-.46.67-.96 0-.387-.267-.79-.872-.79-.637 0-1.024.412-1.024 1.073h-.846c0-1.218.814-1.88 1.87-1.88 1.186 0 1.759.767 1.759 1.582 0 .887-.662 1.306-1.138 1.62z" }), "Guideline");
//# sourceMappingURL=Guideline.js.map